module.exports = __webpack_public_path__ + "static/media/logout-icon.10cb3404.svg";